// extracted by mini-css-extract-plugin
export default {"tinyEditor":"editor_tinyEditor__a6hzA","loading":"editor_loading__RX81+","orgName":"editor_orgName__zSDdt"};